export default function Footer() {
  return (
    <footer className="relative py-20 bg-gradient-to-b from-[#18181b] to-[#0f0f11]">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/151e34d9a5807cd608014213251345d2/83f5e4b8fbdb9e6636dc2fdb7fe48e2c.png"
                alt="HushLegal"
                className="h-10 w-auto"
              />
              <span className="text-white text-2xl font-bold">HushLegal</span>
            </div>
            <p className="text-[#a1a1aa] text-base leading-relaxed">
              Legal documents in seconds. Your privilege protected.
            </p>
          </div>
          <div>
            <h4 className="text-white text-lg font-bold mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-[#a1a1aa] hover:text-[#06b6d4] transition-colors text-base cursor-pointer">
                  Features
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="text-[#a1a1aa] hover:text-[#06b6d4] transition-colors text-base cursor-pointer">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-[#a1a1aa] hover:text-[#06b6d4] transition-colors text-base cursor-pointer">
                  Pricing
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-lg font-bold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#faq" className="text-[#a1a1aa] hover:text-[#06b6d4] transition-colors text-base cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                
                  <a href="mailto:sales@hushlegal.com"
                  className="text-[#a1a1aa] hover:text-[#06b6d4] transition-colors text-base cursor-pointer"
                >
                  sales@hushlegal.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#27272a] pt-8">
          <p className="text-[#71717a] text-sm text-center">
            © 2026 HushLegal. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}